export const PAGINATION = {
  "current_page": 1,
  "first_page_url": "http://admin.ds.test/api/merchant/prepaids?page=1",
  "from": 1,
  "last_page": 1,
  "last_page_url": "http://admin.ds.test/api/merchant/prepaids?page=1",
  "next_page_url": null,
  "path": "http://admin.ds.test/api/merchant/prepaids",
  "per_page": 6,
  "prev_page_url": null,
  "to": 3,
  "total": 50
};
